export default __webpack_public_path__ + "static/media/vivo@3x.e6645439.png";